import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { ProfileViewSelection } from '../../../shared/interfaces/profile-view-selection.interface';
import { PostLoginService } from '../../../shared/services/post-login.service';

@Component({
    selector: 'app-drop-down-modal',
    templateUrl: './drop-down-modal.component.html',
    styleUrls: ['./drop-down-modal.component.scss'],
    standalone: false
})
export class DropDownModalComponent implements OnInit {

  @ViewChildren('a') anchorTags: QueryList<any>;

  selections: ProfileViewSelection[];

  constructor(
    private postLoginService: PostLoginService
  ) { }

  ngOnInit() {
    this.postLoginService.sortedRoleSelections$.subscribe((profileViews) => {
      this.selections = profileViews;
    });
  }

  public focusFirstItem() {
    const x = this.anchorTags.first();
  }
}
